import { CrashType } from "../crashReporting/CrashReport.model";

/// Display label for a crash group's `report_type`, which arrives from the API as the bare enum
/// key. An ANR is called an "ANR" on Android and an "app hang" everywhere else — the same split
/// the release-health cards use (AppHangFreeSessionsCard.tsx).
export function crashTypeLabel(value: string | null | undefined, isAndroid: boolean) {
  switch (value) {
    case CrashType.FATAL:
      return "Fatal";
    case CrashType.NON_FATAL:
      return "Non-fatal";
    case CrashType.ANR:
      return isAndroid ? "ANR" : "App hang";
    default:
      return "";
  }
}
